import { render, staticRenderFns } from "./event.vue?vue&type=template&id=740c8941&"
import script from "./event.vue?vue&type=script&lang=js&"
export * from "./event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiHomeCarouselEventDetails: require('/var/web/bet777.es/themes/dark/ui/Home/CarouselEventDetails.vue').default,UiHomeCarouselEventOutcomes: require('/var/web/bet777.es/themes/dark/ui/Home/CarouselEventOutcomes.vue').default,UiHomeCarouselEvent: require('/var/web/bet777.es/themes/dark/ui/Home/CarouselEvent.vue').default})
